<template>
  <div>
    <input-with-validation :disabled="readOnly" class="form-datepicker" type="number" step="any" :vid="randomVid" :field-label="$attrs.label"
                           :rules="rules" :placeholder="placeholder" b-name="datetimepicker" v-model="castedModel">
    </input-with-validation>
  </div>
</template>

<script>
import ElementRendererMixin from "@/components/form_builder/ElementRendererMixin";
import InputWithValidation from "@/components/validation/InputWithValidation.vue";

export default {
  name: "DatetimeElementSettings",
  components: {InputWithValidation},
  mixins: [ElementRendererMixin],
  computed: {
    castedModel: {
      get() {
        return this.model ? this.$helpers.getDate({ date: this.model, withoutTimezone: true}).utc().toDate() : null;
      },
      set(newVal) {
        this.model = newVal ? this.$helpers.getDate({ date: this.model, withoutTimezone: true}).utc().toString() : null
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .form-datepicker {
    :deep() {
      .field {
        position: relative;
      }
      .datepicker.control {
        position: absolute;
        width: 100%;
        //width: calc(100% - 40px);
        //z-index: 99;
      }
      .component-wrapper {
        height: 40px;
        //position: relative;
      }
    }
  }
</style>
